import { type ResourceKeysStructure } from '../main';
import type defaultResources from './common.cs';

export default {
	'close.label': 'Zavrieť',
	'yes.label': 'Áno',
	'no.label': 'Nie',
	language: {
		label: 'Neznáme',
		label_1: 'Čeština',
		label_2: 'Slovenčina',
		label_3: 'Angličtina',
		label_4: 'Nemčina',
		label_5: 'Francúzština',
		label_6: 'Španielčina',
		label_7: 'Ruština',
		label_8: 'Nórčina',
		label_9: 'Švédčina',
	},
	chipType: {
		label: 'Neznáme',
		label_1: 'Bežný čip',
		label_2: 'Čip dobitý online',
		label_3: 'VIP čip',
		label_4: 'Anonymná transakcia',
		label_5: 'Zamestnanecký čip',
		label_6: 'Čip pre hostí',
	},
	country: {
		label: 'Neznáme',
		label_1: 'Česká republika',
		label_2: 'Slovensko',
		label_3: 'Rakúsko',
		label_4: 'Spojené kráľovstvo Veľkej Británie a Severného Írska',
		label_5: 'Srbsko',
		label_6: 'Belgicko',
		label_7: 'Bulharsko',
		label_8: 'Chorvátsko',
		label_9: 'Cyprus',
		label_10: 'Dánsko',
		label_11: 'Estónsko',
		label_12: 'Fínsko',
		label_13: 'Francúzsko',
		label_14: 'Nemecko',
		label_15: 'Grécko',
		label_16: 'Maďarsko',
		label_17: 'Írsko',
		label_18: 'Taliansko',
		label_19: 'Lotyšsko',
		label_20: 'Litva',
		label_21: 'Luxembursko',
		label_22: 'Malta',
		label_23: 'Poľsko',
		label_24: 'Portugalsko',
		label_25: 'Rumunsko',
		label_26: 'Slovinsko',
		label_27: 'Španielsko',
		label_28: 'Švédsko',
		label_29: 'Holandsko',
		label_30: 'Island',
		label_31: 'Lichtenštajnsko',
		label_32: 'Nórsko',
		label_33: 'Švajčiarsko',
	},
	currency: {
		label: 'Neznáme',
		label_1: 'Koruna',
		label_2: 'Euro',
		label_3: 'Srbský dinár',
		label_4: 'Britská libra',
		label_5: 'Poľský zlotý',
	},
	reqProvider: {
		label: 'Neznáme',
		label_1: 'Email',
		label_2: 'Facebook',
		label_3: 'Google',
		label_4: 'Apple',
	},
	eventCategory: {
		label: 'Neznáme',
		label_1: 'Hudba',
		label_2: 'Gastro',
		label_3: 'Kultúra',
		label_4: 'Víno',
		label_5: 'Športové',
		label_6: 'Sériová akcia',
		label_7: 'Festival',
		label_8: 'Deti',
		label_9: 'Párty',
		label_10: 'Divadlo',
		label_11: 'Koncert',
		label_12: 'Pivo',
	},
	eventKind: {
		label: 'Neznáme',
		label_1: 'Jednorazová akcia',
		label_2: 'Dlhodobá prevádzka',
	},
	eventSize: {
		label: 'Neznáme',
		label_1: 'Malá',
		label_2: 'Stredná',
		label_3: 'Veľká',
	},
	eventType: {
		label: 'Neznáme',
		label_1: 'Vstupenky',
		label_2: 'Balíčky',
		label_3: 'Dobitie kreditu',
	},
	itemType: {
		label: 'Neznáme',
		label_1: 'Vstup na akciu',
		label_2: 'Parkovanie',
		label_3: 'NFC čip',
		label_4: 'Vstup na atrakciu',
		label_5: 'Workshop',
		label_6: 'Produkt',
		label_7: 'Opakovaný vstup na akciu',
		label_8: 'NFC čip VIP',
		label_9: 'Zóna',
	},
	paymentMethod: {
		label: 'Neznáme',
		label_1: 'Platobná karta',
		label_2: 'Bankový prevod',
		label_3: 'Google Pay',
		label_4: 'Apple Pay',
		label_5: 'Terminál v mobile',
		label_6: 'Hotovosť',
		label_7: 'Čip',
		label_8: 'VIP čip',
		label_9: 'Tickets voucher',
		label_10: 'Partnerské',
		label_11: 'Click To Pay',
		label_12: 'Platobná karta',
		label_13: 'Google Pay',
		label_14: 'Apple Pay',
		label_15: 'Click To Pay',
	},
	productCategory: {
		label: 'Neznáme',
		label_1: 'Nealko',
		label_2: 'Pivo',
		label_3: 'Víno',
		label_4: 'Ostatný alkohol',
		label_5: 'Slané',
		label_6: 'Sladké',
		label_7: 'Doplnkový sortiment',
	},
	region: {
		label: 'Neznáme',
		label_1: 'Hl. mesto Praha',
		label_2: 'Stredočeský kraj',
		label_3: 'Juhočeský kraj',
		label_4: 'Plzenský kraj',
		label_5: 'Karlovarský kraj',
		label_6: 'Ústecký kraj',
		label_7: 'Liberecký kraj',
		label_8: 'Královohradecký kraj',
		label_9: 'Pardubický kraj',
		label_10: 'Kraj Vysočina',
		label_11: 'Juhomoravský kraj',
		label_12: 'Olomoucký kraj',
		label_13: 'Zlínsky kraj',
		label_14: 'Moravskosliezsky kraj',
		label_201: 'Bratislavský kraj',
		label_202: 'Trnavský kraj',
		label_203: 'Trenčiansky kraj',
		label_204: 'Nitriansky kraj',
		label_205: 'Žilinský kraj',
		label_206: 'Banskobystrický kraj',
		label_207: 'Prešovský kraj',
		label_208: 'Košický kraj',
		label_301: 'Viedeň',
		label_302: 'Dolné Rakúsko',
		label_303: 'Horné Rakúsko',
		label_304: 'Štajersko',
		label_305: 'Korutánsko',
		label_306: 'Burgenland',
		label_307: 'Salzbursko',
		label_308: 'Tirolsko',
		label_309: 'Vorarlbersko',
		label_501: 'Vojvodina',
		label_502: 'Belehrad',
		label_503: 'Kosovo',
		label_504: 'Metochie',
		label_505: 'Šumadija a Západné Srbsko',
		label_506: 'Južné a Východné Srbsko',
		label_1501: 'Attika',
		label_1502: 'Stredné Grécko',
		label_1503: 'Stredná Macedónia',
		label_1504: 'Kréta',
		label_1505: 'Východná Macedónia a Trácia',
		label_1506: 'Epirus',
		label_1507: 'Jónske ostrovy',
		label_1508: 'Severné Egeis',
		label_1509: 'Peloponéz',
		label_1510: 'Južné Egeis',
		label_1511: 'Thessália',
		label_1512: 'Západné Grécko',
		label_1513: 'Západná Macedónia',
		label_1401: 'Bádensko-Württembersko',
		label_1402: 'Bavorsko',
		label_1403: 'Berlín',
		label_1404: 'Brandenburg',
		label_1405: 'Brémy',
		label_1406: 'Hamburg',
		label_1407: 'Hesensko',
		label_1408: 'Dolné Sasko',
		label_1409: 'Meklenbursko-Predpomoransko',
		label_1410: 'Severné Porýnie-Vestfálsko',
		label_1411: 'Porýnie-Falcko',
		label_1412: 'Sársko',
		label_1413: 'Sasko',
		label_1414: 'Sasko-Anhaltsko',
		label_1415: 'Šlezvicko-Holštajnsko',
		label_1416: 'Durínsko',
	},
	sectionType: {
		label: 'Neznáme',
		label_1: 'Populárne',
		label_2: 'Náš výber',
		label_3: 'Práve prebieha',
		label_4: 'Tento víkend',
		label_5: 'Práve oznámené',
		label_6: 'Špeciálne',
		label_7: 'Blízko mňa',
	},
	venueType: {
		label: 'Neznáme',
		label_1: 'Štadión',
		label_2: 'Kemp',
		label_3: 'Areál na lúke',
		label_4: 'Vonkajšie divadlo/kino',
		label_5: 'Divadlo/kino',
		label_6: 'Mesto',
		label_7: 'Hudobný klub',
	},
} as const satisfies ResourceKeysStructure<typeof defaultResources>;
